import React from "react";
var __jsx = React.createElement;
import { memo } from "react";
import { useTranslation } from "react-i18next";
import AwesomeIcon from "../../AwesomeIcon";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import TextInput from "../../FormComponents/TextInput";
var EnterCountView = /*#__PURE__*/memo(function EnterCountView(_ref) {
  var scanCount = _ref.scanCount,
    inputRef = _ref.inputRef,
    onInputChange = _ref.onInputChange,
    onSubmitCount = _ref.onSubmitCount,
    isSubmitting = _ref.isSubmitting,
    isSubmitDisabled = _ref.isSubmitDisabled,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 min-h-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "drag-handle cursor-grab active:cursor-grabbing rounded-t-2xl bg-gray-800 flex items-center justify-between px-6 py-4 relative border border-gray-700 shrink-0"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-white text-base font-medium"
  }, t("enter_count", "Enter count")), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: "text-gray-400 hover:text-gray-200 transition-colors p-1",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "lg"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-h-0 flex flex-col items-center justify-center px-8 overflow-y-auto"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-gray-300 text-base mb-6"
  }, t("enter_total_scan_count", "Enter total scan count")), /*#__PURE__*/React.createElement("div", {
    className: "w-full max-w-[160px]"
  }, /*#__PURE__*/React.createElement(TextInput, {
    inputRef: inputRef,
    type: "text",
    inputMode: "numeric",
    value: scanCount,
    onChange: onInputChange,
    placeholder: "",
    autoFocus: true,
    isClinicalField: true,
    disabled: isSubmitting,
    wrapperClassName: "!bg-transparent !border-0 !py-0",
    className: "!bg-gray-700/60 !rounded-xl !border !border-gray-600/30",
    inputClassName: "!text-2xl !font-light !text-center !py-3 !px-4 !text-white !bg-transparent !border-b-2 !border-teal-500/50 hover:!border-teal-500"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "px-6 pb-6 shrink-0"
  }, !scanCount.length && /*#__PURE__*/React.createElement("div", {
    className: "text-center mb-6"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-gray-400 text-sm italic"
  }, t("advised_count_info", "Adviced count of images: 84 , Adviced count of cineclips: >12")), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-500 text-sm mt-1"
  }, t("total_count_info", "Total count is the sum of all captured still images and cine clips"))), /*#__PURE__*/React.createElement("button", {
    onClick: onSubmitCount,
    disabled: isSubmitDisabled,
    "aria-disabled": isSubmitDisabled,
    className: ["w-full py-4 rounded-xl text-white text-lg font-medium transition-all duration-200", isSubmitDisabled ? "bg-gray-700 text-gray-300 cursor-not-allowed" : "bg-teal-600 hover:bg-teal-700 hover:scale-[1.01] active:scale-[0.99]"].join(" ")
  }, isSubmitting ? t("common.saving", "Saving...") : t("submit", "Submit"))));
});
export default EnterCountView;